import {writable} from "svelte/store";

const store = writable([]);

class QuestionAB {
  get store() {
    return store;
  }
}

export default QuestionAB;